import headerImgEn from "assets/images/v125/header-en.webp"
import infoImgEn from "assets/images/v125/info-en.webp"

export const v125ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
